import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, XCircle } from "lucide-react";
import { isSignInWithEmailLink, signInWithEmailLink } from "firebase/auth";
import { firebaseAuth } from "@/lib/firebase";
import { trackLogin } from "@/lib/analytics";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export default function VerifyMagicLink() {
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    if (!isSignInWithEmailLink(firebaseAuth, window.location.href)) {
      setError("Invalid sign-in link.");
      return;
    }

    const email = window.localStorage.getItem("emailForSignIn");
    if (!email) {
      setError("Email not found. Please request a new sign-in link.");
      return;
    }

    signInWithEmailLink(firebaseAuth, email, window.location.href)
      .then(() => {
        trackLogin("magic_link");
        window.localStorage.removeItem("emailForSignIn");
        navigate("/dashboard", { replace: true });
      })
      .catch((err: Error) => setError(err.message ?? "Verification failed."));
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <Card className="w-full max-w-sm">
        <CardContent className="py-12 text-center space-y-4">
          {error ? (
            <>
              <XCircle className="h-10 w-10 text-destructive mx-auto" />
              <p className="font-medium text-destructive">{error}</p>
              <Button variant="outline" onClick={() => navigate("/login")}>
                Back to sign in
              </Button>
            </>
          ) : (
            <>
              <Loader2 className="h-10 w-10 text-primary mx-auto animate-spin" />
              <p className="text-muted-foreground">Signing you in…</p>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
